import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Home from "./components/home/Home";
import QuienesSomos from "./components/quienesSomos/QuienesSomos";
import PoliticaDevolucion from "./components/quienesSomos/PoliticaDevolucion";
import ByC from "./components/quienesSomos/ByC";
import NotFound from "./components/notFound/NotFound";

function App() {
  // 👇 Definís las rutas en un array
  const appRoutes = [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/quienes-somos",
      element: <QuienesSomos />,
    },
    {
      path: "/politica-devolucion",
      element: <PoliticaDevolucion />,
    },
    {
      path: "/bases-condiciones",
      element: <ByC />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  // 👇 Se lo pasás al router
  const router = createBrowserRouter(appRoutes);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
